// <product-gallery>: main <swiper-slider> + thumbnail <swiper-slider> (linked with Swiper Thumbs).
// Thumbnail buttons jump the main slider (Swiper ignores taps that start on a button), the active
// thumbnail gets aria-current, and playing videos pause when their slide leaves view.
// product-info.js calls setActiveMedia() with the variant's featured media on variant change.
if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      async connectedCallback() {
        // swiper-slider.js is injected by swiper-assets and may load after this file
        await customElements.whenDefined('swiper-slider');
        this.mainSlider = this.querySelector('.product-gallery__main');
        this.mediaIds = [...this.mainSlider.querySelectorAll('swiper-slide[data-media-id]')].map(
          (slide) => slide.dataset.mediaId
        );
        this.thumbButtons = [...this.querySelectorAll('.product-gallery__thumb-button')];
        this.thumbButtons.forEach((button, index) => button.addEventListener('click', () => this.show(index)));

        this.mainSlider.ready.then((swiper) => {
          swiper.on('slideChange', () => this.onSlideChange(swiper.realIndex));
        });
      }

      show(index) {
        this.mainSlider.ready.then((swiper) => (swiper.params.loop ? swiper.slideToLoop(index) : swiper.slideTo(index)));
      }

      setActiveMedia(mediaId) {
        const index = this.mediaIds?.indexOf(mediaId) ?? -1;
        if (index !== -1) this.show(index);
      }

      onSlideChange(index) {
        this.thumbButtons.forEach((button, i) => button.toggleAttribute('aria-current', i === index));
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.querySelectorAll('.js-youtube').forEach((video) =>
          video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        );
        this.querySelectorAll('.js-vimeo').forEach((video) => video.contentWindow?.postMessage('{"method":"pause"}', '*'));
      }
    }
  );
}
